import { Attachment } from './attachment'
import { BlockTypeEnum } from './block-type-enum'
import { HandoutBizTypeEnum } from './handout-biz-type-enum'
import { Question } from './question'

export interface BlockInterface {
  /**
   * - expand
   *  关联全部题目
   */
  questions?: Question[] | null
  /**
   * - expand
   *  关联题干题目
   */
  question?: Question | null
  isImportantByStudent?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  /**
   * 所在学案id
   */
  handoutId?: number
  /**
   * 所在大纲id
   */
  outlineId?: number
  /**
   * 所在文档id
   */
  documentId?: number
  /**
   * 父ID
   */
  parentId?: number
  /**
   * 源ID
   */
  originId?: number
  /**
   * 业务类型
   */
  bizType?: HandoutBizTypeEnum | null
  /**
   * 业务ID
   */
  bizId?: number
  /**
   * 块类型
   */
  type: BlockTypeEnum
  /**
   * 关联题目 id
   */
  questionId?: number
  /**
   * 关联题目 vid
   */
  questionVid?: number
  /**
   * 关联题目 ids
   */
  questionIds?: number[]
  /**
   * 本块的 hash 值
   */
  hash: string
  /**
   * 权重
   */
  weight?: number
  /**
   * 富文本内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: Attachment[]
  creatorId?: number
  vid?: number
  isPublished?: boolean
  isImportant?: boolean
}

export class Block implements BlockInterface {
  /**
   * - expand
   *  关联全部题目
   */
  questions?: Question[] | null
  /**
   * - expand
   *  关联题干题目
   */
  question?: Question | null
  isImportantByStudent?: boolean
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
  /**
   * 所在学案id
   */
  handoutId?: number
  /**
   * 所在大纲id
   */
  outlineId?: number
  /**
   * 所在文档id
   */
  documentId?: number
  /**
   * 父ID
   */
  parentId?: number
  /**
   * 源ID
   */
  originId?: number
  /**
   * 业务类型
   */
  bizType?: HandoutBizTypeEnum | null
  /**
   * 业务ID
   */
  bizId?: number
  /**
   * 块类型
   */
  type: BlockTypeEnum
  /**
   * 关联题目 id
   */
  questionId?: number
  /**
   * 关联题目 vid
   */
  questionVid?: number
  /**
   * 关联题目 ids
   */
  questionIds?: number[]
  /**
   * 本块的 hash 值
   */
  hash: string
  /**
   * 权重
   */
  weight?: number
  /**
   * 富文本内容
   */
  content?: string
  /**
   * 附件
   */
  attachments?: Attachment[]
  creatorId?: number
  vid?: number
  isPublished?: boolean
  isImportant?: boolean

  constructor(props: BlockInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      questions: _questions,
      question: _question,
      isImportantByStudent: _isImportantByStudent,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      handoutId: _handoutId,
      outlineId: _outlineId,
      documentId: _documentId,
      parentId: _parentId,
      originId: _originId,
      bizType: _bizType,
      bizId: _bizId,
      type: _type,
      questionId: _questionId,
      questionVid: _questionVid,
      questionIds: _questionIds,
      hash: _hash,
      weight: _weight,
      content: _content,
      attachments: _attachments,
      creatorId: _creatorId,
      vid: _vid,
      isPublished: _isPublished,
      isImportant: _isImportant,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.questions = _questions
      ? _questions.map((i) => new Question(i))
      : _questions
    this.question = _question ? new Question(_question) : _question
    this.isImportantByStudent = _isImportantByStudent
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
    this.handoutId = _handoutId
    this.outlineId = _outlineId
    this.documentId = _documentId
    this.parentId = _parentId
    this.originId = _originId
    this.bizType = _bizType
    this.bizId = _bizId
    this.type = _type
    this.questionId = _questionId
    this.questionVid = _questionVid
    this.questionIds = _questionIds
    this.hash = _hash
    this.weight = _weight
    this.content = _content
    this.attachments = _attachments
      ? _attachments.map((i) => new Attachment(i))
      : _attachments
    this.creatorId = _creatorId
    this.vid = _vid
    this.isPublished = _isPublished
    this.isImportant = _isImportant
  }
}
